@import "../../../styles/variables.scss";

.highlight {
  font-weight: bold;
}

.result-card__title {
  text-decoration: none;
  margin: 0;
  font-size: 18px;
  line-height: 30px;
  font-weight: 400;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: break-spaces;
  word-break: break-all;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-clamp: 3;

  qds-icon {
    margin-left: 8px;
  }
}

.ec-widget__container {
  color: #333333;
  background-color: white;
  border: 1px solid white;
  word-break: break-word;
  box-shadow: 0px 2px 10px 0px rgba(51, 51, 51, 0.15);
}

.ec-widget__container-dashboard {
  color: #333333;
  background-color: white;
  border: 1px solid white;
  word-break: break-word;
  box-shadow: 0px 2px 10px 0px rgba(51, 51, 51, 0.15);
  height: calc(100% - 40px);
  @media (max-width: $uiaas-tablet) {
    padding: 16px;
    box-shadow: none;
  }
}

.ec-widget__title {
  font-size: 18px;
  font-weight: 700;
  line-height: 20.79px;
  letter-spacing: 0%;
  padding: 20px 20px 12px 20px;
  margin: 0;
}

.ec-widget__subtitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e6e6e6;
  padding: 0 20px 20px 20px;

  .ec-widget__description-dashboard {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0px;
    color: #626469;
  }

  .ec-widget__view-all {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0%;
  }
}

.ec-widget__description-dashboard {
  font-size: 14px;
  margin: 0;
}

.ec-widget__description {
  font-size: 14px;
  margin: 0;
  padding-bottom: 12px;
  border-bottom: 1px solid #e7e6e6;
}

ul {
  display: flex;

  @media screen and (max-width: 780px) {
    flex-direction: column;
  }
}

.ec-widget__list-dashboard {
  list-style: none;
  padding: 20px;
  margin: 0;
  font-size: 16px;
  -moz-column-count: 2;
  -moz-column-gap: 45px;
  -webkit-column-count: 2;
  -webkit-column-gap: 45px;
  column-count: 2;
  column-gap: 45px;
}

.ec-widget__answer-container {
  display: flex;
  width: 50%;

  qds-standalone-link {
    margin-left: 16px;
  }
}

.ec-widget__list {
  list-style: none;
  margin: 20px 0 0 0;
  padding: 0;
  font-size: 16px;
}
@media (min-width: 900px) {
  .ec-widget__list-element {
    margin-bottom: 20px;
  }
}

.ec-widget__link {
  text-decoration: none;
  color: #1a0dab;
  display: flex;
  justify-content: space-between;
  &-dashboard {
    @extend .ec-widget__link;
    justify-content: end;
  }
}

.ec-widget__link:hover {
  .ec-widget__link-text {
    text-decoration: underline;
  }
}

.ec-widget__link-container-dashboard {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ec-widget__link-text-dashboard {
  -webkit-line-clamp: 2;
  line-clamp: 2;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  word-break: break-word;
  font-weight: 400;
  font-size: 18px;
  line-height: 30px;
  letter-spacing: 0px;
}

.ec-widget__view-all {
  display: flex;
  justify-content: flex-end;
}

.ec-widget-link {
  --qds-control-standard-height: auto;
}

dashboard-community-item {
  width: 50%;
  @media screen and (max-width: 780px) {
    width: 100%;
  }

  .document__container {
    min-height: 100%;
  }
}
